export default "__VITE_ASSET__DKCs3pYc__"